<template>
  <div class="w-full flex justify-between items-center p-2 px-4 border-b bg-white bg-opacity-[3%] border-b-white/5">
    <div class="flex justify-start items-center">
      <p class="text-white">{{ pool.pool_name }}</p>
      <div class="p-0.5 px-2 ml-2 bg-white/5 rounded-md text-xs" v-if="pool.oversub">OVERSUB METHOD</div>
    </div>

    <button @click="collapse = !collapse" class="btn btn-ghost btn-sm btn-circle">
      <Icon v-if="!collapse" name="solar:minimize-line-duotone"></Icon>
      <Icon v-if="collapse" name="solar:maximize-bold-duotone"></Icon>
    </button>
  </div>

  <table v-if="!collapse" class="hidden w-full sm:table table-zebra">

    <thead class="uppercase ">
      <tr>
        <th class="text-turquoise-500  font-normal tracking-widest">price</th>
        <th class="text-turquoise-500  font-normal tracking-widest">allocation</th>
        <th class="text-turquoise-500  font-normal tracking-widest">markup</th>
        <th class="text-turquoise-500  font-normal tracking-widest">markup %</th>
        <th class="text-turquoise-500  font-normal tracking-widest">owner</th>
        <th class="text-turquoise-500  font-normal tracking-widest">status</th>
        <th></th>
      </tr>
    </thead>

    <tbody>

      <tr v-for="_listing in pool.listings">
        <td>{{ (_listing.price).toFixed(2) }} {{ _listing.currency }} </td>
        <td> {{ (_listing.allocation).toFixed(2) }} {{ _listing.currency }}</td>
        <td> {{ (_listing.markup).toFixed(2) }} {{ _listing.currency }}</td>
        <td> {{ ((_listing.markup / _listing.allocation) * 100).toFixed(2) }} %</td>
        <td> {{ _listing.owner.substring(0, 6) }}...</td>
        <td> {{ listingStatus(_listing) }}</td>
        <td class="w-full flex justify-end items-center">
          <button v-if="shouldShowUnlistButton(_listing)" @click="confirmUnlist(_listing)"
            class="btn btn-xs bg-white/10 text-red-500 w-16">unlist</button>

          <OTCViewListingModal v-else :listing="_listing" :project="project" :pool="pool">
            <button class="btn btn-xs bg-white/10 text-turquoise-500 w-16">view</button>
          </OTCViewListingModal>

        </td>
      </tr>

    </tbody>
  </table>

  <div v-if="!collapse" class="w-full sm:hidden">
    <div v-for="_listing in pool.listings"
      class="border-b border-b-white/10 p-4 grid grid-cols-6 justify-center items-center">

      <div class="col-span-2">
        <p class="text-sm uppercase tracking-widest">price</p>
        <p class="text-white text-lg">{{ Number(_listing.price).toFixed(2) }} {{ _listing.currency }}</p>
      </div>

      <div class="col-span-3">
        <p class="text-sm">
          <span class="text-woodsmoke-300">Allocation</span>&nbsp;
          <span class="text-woodsmoke-50">{{ Number(_listing.allocation).toFixed(2) }} {{ _listing.currency }}</span>
        </p>

        <p class="text-sm">
          <span class="text-woodsmoke-300">Markup</span>&nbsp;
          <span class="text-woodsmoke-50">{{ Number(_listing.price - _listing.allocation).toFixed(2) }} {{ _listing.currency }} ({{
            Number(((_listing.price - _listing.allocation) / _listing.allocation) * 100).toFixed(2) }} %)</span>
        </p>

        <p class="text-sm">
          <span class="text-woodsmoke-300">Status</span>&nbsp;
          <span class="text-woodsmoke-50">{{  listingStatus(_listing) }}</span>
        </p>

        <!-- <p class="text-sm">
                <span class="text-woodsmoke-300">Owner</span>&nbsp;
                <span class="text-woodsmoke-50">{{ _listing.owner.substring(0,6) }}...</span>
              </p> -->


      </div>

      <div class="w-full flex justify-end items-center">

        <button @click="confirmUnlist(_listing)" v-if="shouldShowUnlistButton(_listing)"
          class="btn bg-white/10 min-h-0 h-auto py-2 text-red-500">unlist</button>

        <OTCViewListingModal v-else :listing="_listing" :pool="pool" :project="project">
          <button class="btn bg-white/10 min-h-0 h-auto py-2 text-white">view</button>
        </OTCViewListingModal>
      </div>

    </div>
  </div>
</template>

<script setup>

import { useUserStore } from "~/stores/user.js";
const userStore = useUserStore();
const emit = defineEmits(["unlisted"])

const listingStatus = (_listing) => {
  if(_listing.bought) return _listing.is_owner ? "Sold" : "Bought"
  if(_listing.unlisted) return "Unlisted"
  
  return 'Active'
}


function shouldShowUnlistButton(listing) {
  if (listing.is_owner) {
    if (listing.bought || listing.unlisted || !listing.active) return false
    return true
  }
  return false
}

function confirmUnlist(list) {
  if (confirm("Do you want to unlist?")) {
    $fetch(`/api/otc/list/${list.id}`, {
      headers: {
        'Authorization': `Bearer ${$accessToken.value}`
      },
      method: "DELETE"
    })
      .then(() => {
        emit('unlisted')
      })
      .catch(err => {
        alert(err.message)
      })
  }
}

const props = defineProps({
  pool: Object,
  project: Object
});

const { pool, project } = toRefs(props);

const collapse = ref(false);

</script>

<style></style>